import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import JoinView from "../views/join";

const mapStateToProps = (state) => {
  return {
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
    isConnected: state.session.isConnected,
    noRoomFound: state.session.noRoomFound,
    isLoading: state.session.sessionStatus === "LOADING_ROOM" || state.session.sessionStatus === "LOADING_SCENE",
    isEstablishingConnection: state.session.isEstablishingConnection,
    connectionQualityFailed: state.session.connectionQuality.status === "failed",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequestJoinRoom: (data) => {
      dispatch(sessionSlice.actions.emitRequestJoinRoom(data));
    },
    onResetErrors : () => {
      dispatch(sessionSlice.actions.resetErrors());
    },
    onStartConnecting: (data) => {
      dispatch(sessionSlice.actions.startConnecting());
    }
  };
};

export const JoinViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JoinView);
